import i18n from "i18n";

const columns = [
    {
      name: 'name',
      pill: false,
      title: i18n.t("name").toUpperCase(),
      mobileTag: false,
    },
    {
      name: 'description',
      pill: false,
      title: i18n.t("description").toUpperCase(),
      mobileTag: i18n.t("description").concat(": ") ,
  
    },
  ];

  export default columns